var _rect, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEx4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    rx: 35,
    fill: "#F44336"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.4173 23.3332C40.4178 19.8815 43.2165 17.0837 46.6683 17.0842C50.1201 17.0848 52.9178 19.8834 52.9173 23.3352C52.9168 26.787 50.1181 29.5848 46.6663 29.5842L42.9165 29.5836V40.4182L46.6663 40.4176C50.1181 40.417 52.9168 43.2148 52.9173 46.6666C52.9178 50.1184 50.1201 52.917 46.6683 52.9176C43.2165 52.9181 40.4178 50.1203 40.4173 46.6685L40.4167 42.9167H29.5846L29.584 46.6685C29.5834 50.1203 26.7848 52.9181 23.333 52.9176C19.8812 52.917 17.0834 50.1184 17.084 46.6666C17.0845 43.2148 19.8832 40.417 23.335 40.4176L27.0832 40.4182V29.5836L23.335 29.5842C19.8832 29.5848 17.0845 26.787 17.084 23.3352C17.0834 19.8834 19.8812 17.0848 23.333 17.0842C26.7848 17.0837 29.5834 19.8815 29.584 23.3332L29.5846 27.0834H40.4167L40.4173 23.3332ZM27.0846 27.0834L27.084 23.3336C27.0837 21.2626 25.4045 19.5839 23.3334 19.5842C21.2623 19.5846 19.5837 21.2638 19.584 23.3348C19.5843 25.4059 21.2635 27.0846 23.3346 27.0842L27.0846 27.0834ZM46.6679 19.5842C44.5968 19.5839 42.9176 21.2626 42.9173 23.3336L42.9167 27.0836L46.6667 27.0842C48.7378 27.0846 50.417 25.4059 50.4173 23.3348C50.4176 21.2638 48.739 19.5846 46.6679 19.5842ZM29.5832 29.5834V40.4167H40.4165V29.5834H29.5832ZM50.4173 46.667C50.417 44.5959 48.7378 42.9172 46.6667 42.9176L42.9167 42.9182L42.9173 46.6682C42.9176 48.7392 44.5968 50.4179 46.6679 50.4176C48.739 50.4172 50.4176 48.738 50.4173 46.667ZM19.584 46.667C19.5843 44.5959 21.2635 42.9172 23.3346 42.9176L27.0846 42.9182L27.084 46.6682C27.0837 48.7392 25.4045 50.4179 23.3334 50.4176C21.2623 50.4172 19.5837 48.738 19.584 46.667Z",
    fill: "url(#paint0_linear_255_753)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_255_753",
    x1: 35.0006,
    y1: 17.0842,
    x2: 35.0006,
    y2: 52.9176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.46
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEx4);
export default __webpack_public_path__ + "static/media/ex4.e7417064902faac78cea648946070c35.svg";
export { ForwardRef as ReactComponent };